import { render, staticRenderFns } from "./koppel.vue?vue&type=template&id=72c5f37b&scoped=true"
import script from "./koppel.vue?vue&type=script&lang=js"
export * from "./koppel.vue?vue&type=script&lang=js"
import style0 from "./koppel.vue?vue&type=style&index=0&id=72c5f37b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c5f37b",
  null
  
)

export default component.exports